module.exports = __webpack_public_path__ + "e92b901f1edd2ea72de02d75fd2aa10b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/news/img1_1.jpg
// module id = 341
// module chunks = 0